const defaultPanelClass =
  'inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full';

const Modal = ({ isOpen, onClose, children, panelClassName }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500/75 transition-opacity"
          aria-hidden="true"
          onClick={onClose}
        />

        <div className={`relative z-10 ${panelClassName || defaultPanelClass}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
